export const formatMachineNumberWithLine = (machineNumber = "", lineName = "") => {
	const number = String(machineNumber || "").trim();
	const line = String(lineName || "").trim();
	if (!number || !line) return number;
	return `${number} | Line: ${line}`;
};

export const formatMachineNumberFromRow = (row = {}) =>
	formatMachineNumberWithLine(row?.machine_number || row?.machineNumber);
